import * as React from "react";
import { useAccount, State } from "@grandvisionhq/auth";
import { Button } from "@grandvisionhq/common";
import { Divider } from "@grandvisionhq/elements";
import { useLink } from "@grandvisionhq/frk-routing";
import { useIntl } from "@grandvisionhq/state";
import LoginForm from "../../../../components/LoginForm/components/LoginForm/LoginForm.js";
/* empty css           */
const Login = ({ isOrderNumberValid }) => {
  const { getLabel } = useIntl();
  const authState = useAccount();
  const isAuthLoading = authState === "UNKNOWN";
  const isUserLoggedIn = authState === State.AuthState.LoggedIn;
  const { href: returnPath, onClick: onOrdersLink } = useLink({ route: "me.orders" }) || {};
  const { onClick } = useLink(
    isUserLoggedIn ? { route: "me.orders" } : { route: "auth.login", params: { returnPath } }
  ) || {};
  const buttonLabel = !isUserLoggedIn ? "returns.page.login.signIn.cta" : "returns.page.login.orders";
  return /* @__PURE__ */ React.createElement("div", { className: "returns-login" }, /* @__PURE__ */ React.createElement(LoginForm, { isOrderNumberValid }), /* @__PURE__ */ React.createElement(Divider, { caption: getLabel("account.signup.general.or") }), /* @__PURE__ */ React.createElement("div", { className: "returns-login__bottom" }, /* @__PURE__ */ React.createElement(
    Button,
    {
      caption: getLabel(buttonLabel),
      variant: "outline",
      onClick: isUserLoggedIn ? onOrdersLink : onClick,
      className: "returns-login__cta-button",
      isLoading: isAuthLoading
    }
  )));
};
export {
  Login as default
};
//# sourceMappingURL=Login.js.map
